import HeaderNavigationDrawer from './HeaderNavigationDrawer.vue';

export default HeaderNavigationDrawer;
